
export default {
  name: 'NewsArchive',
  setup() {
    const years = []
    const startYear = 2020
    const currentYear = new Date().getFullYear()

    for (let i = startYear; i <= currentYear; i++) {
      years.push(i)
    }

    years.reverse()

    return {
      years
    }
  }
}
